import { defineStore } from "pinia";
import { ref } from "vue";
import useGatewayApi from "@/composables/useGatewayApi";
import useAuthApi from '@/composables/useAuthApi'
import type { Skjal } from '@/types/Skjal';
import type { SkuldabrefResponse } from "@/types/JoakimTypes/SkuldabrefResponse";


export const useJoakimStore = defineStore("joakim", () => {
  const sameignRettindi = ref({ rettindi: [] });
  const sereignRettindi = ref(null);
 const idgjold = ref<any[] | null>(null)
  const onnurrettindi = ref(null);
  const ermedeingreidslu = ref(null);
  const skuldabref = ref(null);
  const reiknalan = ref(null);
  const greidslusaga = ref({ greidslusaga: [] });
  const greidslusagaArs = ref(null);
  const SereignHreyfingar = ref([]);
  const TilgreindHreyfingar = ref([]);
  const reiknudrettindi = ref(null);
  const reiknudrettindiAge = ref(null);
  const reiknudrettindiAgeSpinner = ref(false);
  const acceptedMessage = ref(null);
  const lifeyrissjodir = ref(null);
  const lanaStatus = ref(null)
  const rettindi = ref(null)
  const sereign = ref(null)
  const tilgreindSereign = ref(null)
  const lifeyrirSum = ref(null)
  const sereignSpinner = ref(false)
  const rettindiSpinner = ref(false)
  const lanaSpinner = ref(false)
  const lifeyrirSpinner = ref(false)
  const skjol = ref<Skjal[]>([]);
  const skjolSpinner = ref(false);
  const lifeyrisgattRows = ref<any[]>([])


  const gatewayApi = useGatewayApi();
    const authApi = useAuthApi();

  const getSameign = async () => {
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/getsameign");
      sameignRettindi.value = result;
    } catch (e) {}
  };

  const getSereign = async () => {
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/getsereign");
      sereignRettindi.value = result;
      SereignHreyfingar.value = result.sereignHreyfingar;
      TilgreindHreyfingar.value = result.tilgreindHreyfingar;
    } catch (e) {}
  };

  const getIdgjold = async () => {
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/getidgjold");
      idgjold.value = result.idgjold;
      return result;
    } catch (e) {
      throw e;
    }
  };

  const getSkuldabref = async () => {
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/getskuldabref");
      skuldabref.value = result;
      return result;
    } catch (e) {
      throw e;
    }
  };

  const reiknaLan = async () => {
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/reiknalan");
      reiknalan.value = result;
    } catch (e) {}
  };

  const getOnnurRettindi = async () => {
    const result = await gatewayApi.get(
      "api/v1/core/joakim/lifeyrissjodir/getadridsjodirrettindi"
    );
    onnurrettindi.value = result;
    return result;
  };

  const ermedEingreidsluLifeyris = async () => {
    const result = await gatewayApi.get(
      "api/v1/core/joakim/lifeyrissjodir/ermedeingreidslulifeyris"
    );
    ermedeingreidslu.value = result;
    return result;
  };

  const getGreidslusogu = async () => {
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/getgreidslusogu");
      greidslusaga.value = result;
      return result;
    } catch (e) {
      throw e;
    }
  };

  const getGreidslusoguArs = async (year: number) => {
    try {
      const result = await gatewayApi.get(
        `api/v1/core/joakim/getgreidslusoguars?year=${year}`
      );
      greidslusagaArs.value = result;
      return result;
    } catch (e) {
      throw e;
    }
  };

  const getReiknudRettindi = async () => {
    try {
      const result = await gatewayApi.get(
        "api/v1/core/joakim/getaaetludrettindi"
      );
      reiknudrettindi.value = result;
      return result;
    } catch (e) {
      throw e;
    }
  };

  const getReiknudRettindiAldur = async (age: number) => {
    reiknudrettindiAgeSpinner.value = true;
    try {
      const result = await gatewayApi.get(
        `api/v1/core/joakim/getaaetludrettindiage?age=${age}`
      );
      reiknudrettindiAge.value = result;
      return result;
    } catch (e) {
      throw e;
    } finally {
      reiknudrettindiAgeSpinner.value = false;
    }
  };

  const getHreyfingarDeilda = async (payload: {
    sjodsDeild: string;
    dagsFra: Date;
    dagsTil: Date;
  }) => {
    try {
      const result = await gatewayApi.get(
        `api/v1/core/joakim/hreyfingar?sjodsDeild=${
          payload.sjodsDeild
        }&dagsTil=${payload.dagsTil.toJSON()}&dagsFra=${payload.dagsFra.toJSON()}`
      );
      return result;
    } catch (e) {
      throw e;
    }
  };

  const getSumLifeyrisgatt = async () => {
    if (localStorage.getItem("lifeyrisgatt") === "true") {
      try {
        const result = await gatewayApi.get(
          "api/v1/core/joakim/lifeyrissjodir/sumsjodir"
        );
        lifeyrissjodir.value = result;
      } catch (e) {}
    }
  };

  const getLifeyrisgatt = async (): Promise<any[]> => {
    if (localStorage.getItem('lifeyrisgatt') !== 'true') {
      lifeyrisgattRows.value = []
      return []
    }
    try {
      const res = await gatewayApi.get('api/v1/core/joakim/lifeyrissjodir/sjodir')
      const rows = res?.lifeyrir ?? res?.lifeyrir ?? res ?? []
      lifeyrisgattRows.value = Array.isArray(rows) ? rows : []
      return lifeyrisgattRows.value
    } catch (e) {
      console.error(e)
      lifeyrisgattRows.value = []
      return []
    }
  }


  const checkBankaReikning = (umsokn: any) => {
    return gatewayApi.post("api/v1/core/joakim/bankacheck", umsokn);
  };

  const setRettindi = async () => {
    rettindiSpinner.value = true
    try {
      const result = await gatewayApi.get('api/v1/core/joakim/sjods/sum/rettindi')
      rettindi.value = result
    } catch (e) {
      console.error(e)
    } finally {
      rettindiSpinner.value = false
    }
  }

  const setLan = async () => {
    lanaSpinner.value = true
    try {
      const result = await gatewayApi.get('api/v1/core/joakim/sjods/sum/lan')
      lanaStatus.value = result
    } catch (e) {
      console.error(e)
    } finally {
      lanaSpinner.value = false
    }
  }

  const setSereign = async () => {
    sereignSpinner.value = true
    try {
      const result = await gatewayApi.get('api/v1/core/joakim/sjods/sum/sereign')
      tilgreindSereign.value = result.tilgreind_Sereign_Rettindi
      sereign.value = result.sereign
    } catch (e) {
      console.error(e)
    } finally {
      sereignSpinner.value = false
    }
  }

  const getSumLifeyrisgattBoxes = async () => {
    if (localStorage.getItem('lifeyrisgatt') === 'true') {
      lifeyrirSpinner.value = true
      try {
        const result = await gatewayApi.get('api/v1/core/joakim/lifeyrissjodir/sumsjodir')
        lifeyrirSum.value = result
      } catch (e) {
        console.error(e)
      } finally {
        lifeyrirSpinner.value = false
      }
    }
  }

  const getSkjol = async () => {
    skjolSpinner.value = true;
    try {
      const result = await gatewayApi.get("api/v1/core/joakim/getskjol");
      skjol.value = result.skjol;
    } catch (e) {
      console.error("Failed to fetch skjol", e);
    } finally {
      skjolSpinner.value = false;
    }
  };

const downloadSkjal = async (skjalId: string): Promise<void> => {
  const { data, headers } = await gatewayApi.getBinary(
    `api/v1/core/joakim/getskjal?skjalId=${encodeURIComponent(skjalId)}`
  )

  const contentType = (headers?.['content-type'] || '').toLowerCase()
  if (!contentType.startsWith('application/pdf') && !contentType.startsWith('image/')) {
    // optional: try to decode for diagnostics (like your old TextDecoder)
    try {
      const txt = new TextDecoder().decode(data)
      console.error('Received non-binary content:', txt)
    } catch { /* ignore */ }
    alert('Ekki tókst að sækja skjal. Þjónustan skilaði ekki skjali.')
    return
  }

  // filename from Content-Disposition
  const cd = headers?.['content-disposition'] || ''
  const utf = cd.match(/filename\*=UTF-8''([^;]+)/)
  const simple = cd.match(/filename="?([^"]+)"?/)
  const filename = utf ? decodeURIComponent(utf[1]) : (simple ? simple[1] : 'document.pdf')

  const blob = new Blob([data], { type: contentType })
  const url = URL.createObjectURL(blob)
  const a = Object.assign(document.createElement('a'), { href: url, download: filename })
  document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url)
}



  return {
    sameignRettindi,
    sereignRettindi,
    idgjold,
    onnurrettindi,
    ermedeingreidslu,
    skuldabref,
    reiknalan,
    greidslusaga,
    greidslusagaArs,
    SereignHreyfingar,
    TilgreindHreyfingar,
    reiknudrettindi,
    reiknudrettindiAge,
    reiknudrettindiAgeSpinner,
    acceptedMessage,
    lifeyrissjodir,
    lanaStatus,
    rettindi,
    sereign,
    tilgreindSereign,
    lifeyrirSum,
    sereignSpinner,
    rettindiSpinner,
    lanaSpinner,
    lifeyrirSpinner,
		skjol,
		skjolSpinner,
    lifeyrisgattRows,
		

    // action
    getSameign,
    getSereign,
    getIdgjold,
    getSkuldabref,
    reiknaLan,
    getOnnurRettindi,
    ermedEingreidsluLifeyris,
    getGreidslusogu,
    getGreidslusoguArs,
    getReiknudRettindi,
    getReiknudRettindiAldur,
    getHreyfingarDeilda,
    getSumLifeyrisgatt,
    getLifeyrisgatt,
    checkBankaReikning,
    setRettindi,
    setLan,
    setSereign,
    getSumLifeyrisgattBoxes,
		getSkjol,
		downloadSkjal,
  };
});
